export const environment = {
  production: true,
  baseUrl: 'https://api.nyga.ng/api/v1/',
  idleTimeAllowed: 10080,
  idleTimeout: 3000,
};
